import React from 'react';
import './ConversationList.css';
import ConversationCard from './ConversationCard';

const ConversationList = ({ conversations, onSelect, selectedConversationId, userInfo, unreadCounts = {} }) => {
  if (!conversations || conversations.length === 0) {
    return (
      <div className="conversation-list empty">
        <div className="empty-conversations">
          <p>No conversations yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="conversation-list">
      <div className="conversation-list-header">
        <h2>Conversations</h2>
        <span className="conversation-count">{conversations.length}</span>
      </div>
      
      <div className="conversations">
        {conversations.map((conversation) => {
          const isSelected = selectedConversationId === conversation.conversation_id;
          const unread = unreadCounts[conversation.conversation_id] || 0;
          return (
            <ConversationCard
              key={conversation.conversation_id}
              conversation={{ ...conversation, unread_count: unread }}
              onSelect={onSelect}
              isSelected={isSelected}
              userInfo={userInfo}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ConversationList;
